import { FaUser, FaExchangeAlt, FaTrash, FaEye } from "react-icons/fa";
import Header from "./Header";
import React, { useState, useEffect } from "react";
import { db, auth } from "../../firebase/firebaseConfig";
import Modal from "../../components/modal";
import TransactionReceipt from "./TransactionReceipt";
import {
  collection,
  getDocs,
  query,
  where,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

function Transactions() {
  const [isOpen, setIsOpen] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [, setLoading] = useState(true);
  const [, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [referenceId, setReferenceId] = useState("");
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeComponent, setActiveComponent] = useState(null);

  const openModal = (component) => {
      setActiveComponent(() => component);
      setIsModalOpen(true);
  };

  const closeModal = () => {
      setIsModalOpen(false);
      setActiveComponent(null);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        setUser(null);
        setLoading(false);
        setError("Please log in to view transactions.");
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchTransactions = async () => {
      if (!user) return;
      setLoading(true);
      try {
        let transactionsRef = collection(db, `users/${user.uid}/transactions`);

        let q = query(transactionsRef);

        if (startDate && endDate) {
          q = query(
            transactionsRef,
            where("timestamp", ">=", new Date(startDate)),
            where("timestamp", "<=", new Date(endDate))
          );
        }

        if (referenceId) {
          q = query(transactionsRef, where("id", "==", referenceId));
        }

        const querySnapshot = await getDocs(q);
        const userTransactions = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setTransactions(userTransactions);
        console.log("user transactions: ", userTransactions)
      } catch (err) {
        setError("Error fetching transactions.");
        console.error("Error fetching transactions:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [user, startDate, endDate, referenceId]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleSingleDelete = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this transaction?");
    if (!confirmed) return;

    try {
      await deleteDoc(doc(db, `users/${user.uid}/transactions`, id));
      setTransactions((prev) => prev.filter((transaction) => transaction.id !== id));
    } catch (err) {
      console.error("Error deleting transaction:", err);
    }
  };

  const handleViewTransaction = (transaction) => {
    openModal(() => <TransactionReceipt transaction={transaction} />);
  };


  const handleCheckboxChange = (id) => {
    setSelectedTransactions((prev) =>
      prev.includes(id)
        ? prev.filter((transactionId) => transactionId !== id)
        : [...prev, id]
    );
  };

  const handleBulkDelete = async () => {
    const confirmed = window.confirm("Are you sure you want to delete the selected transactions?");
    if (!confirmed) return;

    try {
      await Promise.all(
        selectedTransactions.map((id) =>
          deleteDoc(doc(db, `users/${user.uid}/transactions`, id))
        )
      );
      setTransactions((prev) =>
        prev.filter((transaction) => !selectedTransactions.includes(transaction.id))
      );
      setSelectedTransactions([]);
    } catch (err) {
      console.error("Error deleting transactions:", err);
    }
  };

  return (
    <div className="header-div bg-light1 text-dark2 dark:text-light1 dark:bg-dark1 min-h-screen">
      <Modal isOpen={isModalOpen} onClose={closeModal} contentComponent={activeComponent} />
      <Header onToggleMenuClick={toggleMenu} isOpen={isOpen} />
      <div className="flex pt-16 w-full lg:w-9/10 mx-auto">
        <main
          className={`${isOpen ? "lg:ml-40" : "lg:ml-11"
            } transition-all duration-300 space-y-8 ease-in-out w-9/10 mx-auto lg:w-screen`}
        >
          <div>
            <div className="flex items-center rounded-lg bg-light2 dark:bg-dark2 p-2">
              <div className="flex items-center mr-auto">
                <div className="flex items-center justify-center mx-2 w-10 h-10 rounded-full bg-light1 dark:bg-dark1">
                  <FaUser />
                </div>
                <span>Joshua C. Odigbo</span>
              </div>
              <span className="text-primary">Transactional History</span>
            </div>
          </div>

          <div className="lg:w-full mx-2 bg-light2 space-y-4 dark:bg-dark2 min-h-36 rounded-lg p-4">
            <div className="flex flex-col lg:flex-row space-y-4 justify-between lg:items-center">
              <span className="flex items-center text-dark0 text-2xl">
                <FaExchangeAlt className="m-2" />
                All Transactions:
              </span>
              <div className="flex flex-col md:flex-row lg:flex-row md:space-x-2 lg:space-x-2 space-y-3 md:space-y-0 lg:space-y-0">
                <span className="space-x-1 text-dark0">
                  Reference ID:
                  <input
                    type="text"
                    value={referenceId}
                    onChange={(e) => setReferenceId(e.target.value)}
                    className="rounded-md text-dark0"
                  />
                </span>
                <span className="space-x-1 text-dark0">
                  from:
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="rounded-md text-dark0"
                  />
                </span>
                <span className="space-x-1 text-dark0">
                  to:
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="rounded-md text-dark0"
                  />
                </span>
              </div>
            </div>
            <button
              className="bg-red-500 text-white p-2 rounded-md"
              onClick={handleBulkDelete}
              disabled={!selectedTransactions.length}
            >
              Delete Selected
            </button>
            <div className="overflow-x-auto">
              <table className="min-w-full border border-dark0">
                <thead>
                  <tr>
                    <th className="px-4 py-2 border border-dark0">
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          setSelectedTransactions(
                            e.target.checked
                              ? transactions.map((t) => t.id)
                              : []
                          )
                        }
                      />
                    </th>
                    <th className="px-4 py-2 border border-dark0">S/N</th>
                    <th className="px-4 py-2 border border-dark0">Type</th>
                    <th className="px-4 py-2 border border-dark0">Network</th>
                    <th className="px-4 py-2 border border-dark0">Amount</th>
                    <th className="px-4 py-2 border border-dark0">Reference ID</th>
                    <th className="px-4 py-2 border border-dark0">Status</th>
                    <th className="px-4 py-2 border border-dark0">Phone</th>
                    <th className="px-4 py-2 border border-dark0">Date</th>
                    <th className="px-4 py-2 border border-dark0">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.length > 0 ? (
                    transactions.map((transaction, index) => (
                      <tr key={transaction.id}>
                        <td className="px-4 py-2 border border-dark0">
                          <input
                            type="checkbox"
                            checked={selectedTransactions.includes(transaction.id)}
                            onChange={() => handleCheckboxChange(transaction.id)}
                          />
                        </td>
                        <td className="px-4 py-2 border border-dark0">
                          {index + 1}
                        </td>
                        <td className="px-4 py-2 border border-dark0">
                          {transaction.type}
                        </td>
                        <td className="px-4 py-2 border border-dark0">
                          {typeof transaction.network === 'string' 
                            ? transaction.network 
                            : transaction.network?.name 
                              ? `${transaction.network.name} ${transaction.network?.code ? `(${transaction.network.code})` : ''}` 
                              : 'N/A'}
                        </td>
                        <td className="px-4 py-2 border border-dark0">
                          ₦{transaction.amount}
                        </td>
                        <td className="px-4 py-2 border border-dark0">
                          {transaction.id}
                        </td>
                        <td className="px-4 py-2 border border-dark0">
                          {transaction.response?.status || 'N/A'}
                        </td>
                        <td className="px-4 py-2 border border-dark0">
                          {transaction.mobileNumber}
                        </td>
                        <td className="px-4 py-2 border border-dark0">
                          {transaction.timestamp ? (transaction.timestamp.toDate ? transaction.timestamp.toDate().toLocaleString() : (transaction.timestamp.seconds ? new Date(transaction.timestamp.seconds * 1000).toLocaleString() : new Date(transaction.timestamp).toLocaleString())) : 'N/A'}
                        </td>
                        <td className="px-4 py-2 border border-dark0">
                          <button
                            className="text-blue-500"
                            onClick={() => handleViewTransaction(transaction)}
                          >
                            <FaEye />
                          </button>
                          <button
                            className="text-red-500"
                            onClick={() => handleSingleDelete(transaction.id)}
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="px-4 py-2 text-center">
                        No transactions found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default Transactions;




